import { SubmitBook } from "@/types/book"

import { apiFetch } from "../utils"
import { postActivityLog } from "./log"

const billingUrl = `himo-billing/`

export async function getBooks() {
  const response = await apiFetch(`${billingUrl}books-per-zone/?size=20`)

  if (!response.ok) {
    throw new Error("Cannot fetch books")
  }

  return await response.json()
}

export async function deleteBook(id: number) {
  const response = await apiFetch(`${billingUrl}books-per-zone/${id}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
    },
  })

  if (!response.ok) {
    await postActivityLog({
      menu_path: "HIMO Billing-Digos Water District-Zone Settings",
      sub_menu_path: "/zone-settings/books-zone",
      action: `Delete Book (${id})`,
      status_code: response.status,
      api_endpoint: response.url,
      web_url: window.location.href,
    })

    throw new Error("Cannot fetch books")
  }

  await postActivityLog({
    menu_path: "HIMO Billing-Digos Water District-Zone Settings",
    sub_menu_path: "/zone-settings/books-zone",
    action: `Delete Book (${id})`,
    status_code: response.status,
    api_endpoint: response.url,
    web_url: window.location.href,
  })

  return await response.json()
}


export async function getBookById(id: number) {
  const response = await apiFetch(`${billingUrl}books-per-zone/${id}`)

  if (!response.ok) {
    throw new Error("Cannot fetch books")
  }

  return await response.json()
}

export async function editBook(data: SubmitBook, id: number) {
  const response = await apiFetch(`${billingUrl}books-per-zone/${id}/`, {
    method: "PUT",
    headers: {
      "Content-type": "application/json",
    },
    body: JSON.stringify(data),
  })

  if (!response.ok) {
    await postActivityLog({
      menu_path: "HIMO Billing-Digos Water District-Zone Settings",
      sub_menu_path: "/zone-settings/books-zone",
      action: `Edit Book (ID ${id})`,
      status_code: response.status,
      api_endpoint: response.url,
      web_url: window.location.href,
    })

    throw new Error(`Error fetching: ${response.statusText}`)
  }

  await postActivityLog({
    menu_path: "HIMO Billing-Digos Water District-Zone Settings",
    sub_menu_path: "/zone-settings/books-zone",
    action: `Edit Book (ID ${id})`,
    status_code: response.status,
    api_endpoint: response.url,
    web_url: window.location.href,
  })

  return await response.json()
}

export async function addBook(data: SubmitBook) {
  const response = await apiFetch(`${billingUrl}books-per-zone/`, {
    method: "POST",
    headers: {
      "Content-type": "application/json",
    },
    body: JSON.stringify(data),
  })

  if (!response.ok) {
    await postActivityLog({
      menu_path: "HIMO Billing-Digos Water District-Zone Settings",
      sub_menu_path: "/zone-settings/books-zone",
      action: `Add Book (${data.name})`,
      status_code: response.status,
      api_endpoint: response.url,
      web_url: window.location.href,
    })

    throw new Error("Cannot fetch books")
  }

  await postActivityLog({
    menu_path: "HIMO Billing-Digos Water District-Zone Settings",
    sub_menu_path: "/zone-settings/books-zone",
    action: `Add Book (${data.name})`,
    status_code: response.status,
    api_endpoint: response.url,
    web_url: window.location.href,
  })

  return await response.json()
}


